export default __webpack_public_path__ + "static/media/banner-dez-anos-seguridade-mobile.cbf08c2b.png";